/**
 * Define Sign Up mixin
 *
 * @author minkyoung.park@emcast.com
 */
export const joinMixin = {
    data() {
        return {
        }
    },
    created() {
        this.$snackClose()
    },

    methods: {
        // 가입취소 팝업(cancel popup sign up)
        cancelJoin() {
            this.$confirm({
                // title: '가입을 취소하시겠습니까?',
                // content: '확인을 누르면 회원가입이 취소됩니다.',
                title: this.$t('1700'),
                content: this.$t('1701'),
                accept:  this.$t('1703'),
                cancel:  this.$t('1702'),
            }).then(() => {
                this.$router.push('/login')
            }).catch(() => {})
        },

        // 첫번째 요소 포커스(set focus first input element)
        focusFirstInvalidElement() {
            let invalidElementName = Object.keys(this.errors.collect())[0]
            this.$refs[`${invalidElementName}`].focus()
        },

        // Guide Popup
        showMessage(mode) {
            if (mode === 1) {
                this.$alert({
                    title: this.$t('1588'),
                    content: this.$t('1589') + '<br>' + this.$t('1590', {str: '<a href="mailto:'+BRAND_MANAGER_EMAIL+'">'+BRAND_MANAGER_EMAIL+'</a>'}) + '<br>' + this.$t('1591', {str: '<a href="tel:'+BRAND_MANAGER_PHONE+'">'+BRAND_MANAGER_PHONE+'</a>'}),
                    accept:  this.$t('1592'),
                    // title:'인증코드를 잊으셨나요?',
                    // content: '소속 인증 기관(부서)로 문의하실 수 있습니다.<br> E-MAIL : support@brand.com <br>문의처 : 82.10.1234.5678'
                }).then(() => {})
            }else if (mode === 2) {
                this.$alert({
                    title: this.$t('1593'),
                    content: this.$t('1594') + '<br>' + this.$t('1595', {str: '<a href="mailto:'+BRAND_MANAGER_EMAIL+'">'+BRAND_MANAGER_EMAIL+'</a>'}) + '<br>' + this.$t('1596', {str: '<a href="tel:'+BRAND_MANAGER_PHONE+'">'+BRAND_MANAGER_PHONE+'</a>'}),
                    accept:  this.$t('1592'),
                    // title:'인증코드가 없으신가요?',
                    // content: '소속 인증 관련 문의는 관리자에게 문의하실 수 있습니다.<br> E-MAIL : support@brand.com <br>문의처 : 82.10.1234.5678'
                }).then(() => {

                })
            }

        },

        moveJoin2Intro() {
            // this.$router.push({name:'Join2Intro'})
            this.$router.go(-1)
        }

    }
}
